<script setup>
import { ref } from 'vue'
import commonService from '../service/common-service.js';
import logService from '../service/log-service.js';

const props = defineProps({
    faoModel: {
        type: Object
    },
    searchString: {
        type : [String, Object],
    },
    faoScreen : {
        type: String
    }
})
const searchtext = ref(props.searchString || "")
const emit = defineEmits(['callByZip', 'callByZipError']);

const zipTextBoxId = "officeFinder-hero-input" + Math.random(1, 1000);

async function searchByZip(event) {
    event.preventDefault();
    logService.eventLog("Zipcode search button clicked");
    if (searchtext.value != null && searchtext.value.length > 0) {
        emit('callByZip', searchtext.value)
    }
    else {
        //if search text is empty call by geolocation
        commonService.getGeoLocation(pos => {
            if (pos != null) {
                emit('callByZip', pos);
            }
        }, err => {
            if (err.code == err.TIMEOUT || err.code == err.UNKNOWN_ERROR) {
                const errorData = { triggerMethod: "FindByZip.searchByZip.geoLocationError", error: { code: err.code, message: err.message } };
                logService.errorLog(JSON.stringify(errorData));
                window.location.href = window.location.hostname === "localhost" ?
                    "http://" + window.location.host + "/officelocator" : "https://" + window.location.hostname + "/officelocator";
            }
            var errorMessage = commonService.getFAOGeoLocationError(err, props.faoModel.geolocationDeniedErrorFAO)
            emit('callByZipError', errorMessage);
        })
    }
}
</script>

<template>
    <form autocomplete="on" onsubmit="return false;">
    <div class="headerFAO-block__zip">
        
        <label :for="zipTextBoxId" class="headerFAO-block__zip-label">
            <span>{{ faoModel.inputLabelFAO }}</span>
            <input :id="zipTextBoxId" class="headerFAO-block__zip-input" type="text" name="zipcode"
                :placeholder="faoModel.inputPlaceholderFAO" pattern="([a-zA-Z\d\s-]+)" inputmode="numeric" 
                :aria-label="faoModel.inputPlaceholderFAO" :title="faoModel.inputPlaceholderFAO"
                v-model="searchtext" @keyup.enter="searchByZip($event)" autocomplete="on">
        </label>
        <button :id="'zipSearchButton-' + faoScreen" type="button" class="headerFAO-block__zip-btn" title="" @click="searchByZip($event)">
            <p v-html="faoModel.zipSearchButtonFAO"></p>
        </button>
    </div>
</form>
</template>

<style scoped>
.headerFAO-block__zip {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-align: end;
    align-items: end;
    margin: 0 20px;
    padding-bottom: 30px;
}

.headerFAO-block__zip-label {
    margin-right: 10px;
}

.headerFAO-block__zip-label span {
    padding: 5px;
}

@media (max-width: 991px) {
    .headerFAO-block__zip-input:focus,
    .headerFAO-block__zip-input:focus-visible {
      outline: none !important;
      box-shadow: 0 0 0 1px #222;
    }
}

.headerFAO-block__zip-btn {
    cursor: pointer;
    border-radius: 50px;
    border: 0;
    transition: all 0.1s ease-in-out;
    padding: 12px 20px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 1em;
    line-height: 1em;
    font-family: OpenSans-SemiBold;
    text-decoration: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    white-space: nowrap;
    background-color: #633981;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
    color: #FFFFFF;
}

.headerFAO-block__zip-btn:hover,
.headerFAO-block__zip-btn:active,
.headerFAO-block__zip-btn:focus {
    transform-origin: center;
    transform: scale(1.1);
    text-decoration: none;
}

.headerFAO-block__zip-btn:hover,
.headerFAO-block__zip-btn:active,
.headerFAO-block__zip-btn:focus {
    color: #FFFFFF;
}

@media (max-width: 991px) {
    .headerFAO-block__zip-btn:focus,
    .headerFAO-block__zip-btn:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px #222;
    }
}

.headerFAO-block__zip-btn.ghost {
    background-color: transparent;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
    color: #633981;
    border: 2px #633981 solid;
}

.headerFAO-block__zip-btn.ghost:hover,
.headerFAO-block__zip-btn.ghost:active,
.headerFAO-block__zip-btn.ghost:focus {
    color: #633981;
}
</style>